import { Container, Stack, Box, Grid, Card, CardContent, Skeleton } from '@mui/material';

export function DashboardLoadingSkeleton() {
  return (
    <Container maxWidth="xl" sx={{ py: 4 }}>
      <Stack spacing={4}>
        {/* Header */}
        <Box>
          <Skeleton variant="text" width={200} height={40} />
          <Skeleton variant="text" width={350} />
        </Box>

        {/* Summary Cards */}
        <Grid container spacing={3}>
          {[...Array(6)].map((_, i) => (
            <Grid size={{ xs: 12, sm: 6, md: 4, lg: 2 }} key={i}>
              <Card sx={{ position: 'relative', overflow: 'visible' }}>
                <CardContent>
                  <Box
                    sx={{
                      position: 'absolute',
                      top: -10,
                      right: 20,
                      width: 40,
                      height: 40,
                    }}
                  >
                    <Skeleton variant="rounded" width={40} height={40} />
                  </Box>
                  <Skeleton variant="text" width={100} />
                  <Skeleton variant="text" width={60} height={50} />
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>

        {/* Chart */}
        <Card>
          <CardContent>
            <Skeleton variant="text" width={200} />
            <Skeleton variant="rectangular" height={300} sx={{ mt: 2 }} />
          </CardContent>
        </Card>

        {/* Recent Tests */}
        <Card>
          <CardContent>
            <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
              <Skeleton variant="text" width={150} />
              <Skeleton variant="text" width={80} />
            </Box>
            <Skeleton variant="rectangular" height={200} />
          </CardContent>
        </Card>
      </Stack>
    </Container>
  );
}
